export class Zone {
  id: number;
  name: string;
}
